import RemittanceCompanies from './RemittanceCompanies';

const RequestLogs = () => (
	<div>
		<RemittanceCompanies />
	</div>
);

export default RequestLogs;
